import { getConfig } from '../common/utils/appConfig';

export const getServer = () => ({
  INTERWOVEN_SERVER: getConfig().interwovenServer,
  CUSTOMER_AUTHORIZATION: getConfig().customerAuthorizationServer,
  CUSTOMER_SECURITY: getConfig().customerSecurityServer,
  CUSTOMER_SECURITY_LOGIN: getConfig().customerSecurityLoginServer,
  SYSTEM_PARAMETER: getConfig().systemParameterServer,
  MS_UI_TOKEN_MANAGEMENT: getConfig().msUiTokenManagement,
});

export const PATH = {
  LOG_OUT: '/v1/logout',
  GET_ACCESS_TOKEN: '/v1/authorization/authorize',
  AUTHORIZATION_REFRESH: '/v1/authorization/token',
  SOFT_TOKEN_REQUEST: '/v1/softToken/request',
  ACCESS_ELEVATION_REQUEST: '/v2/access-elevation/request',
  // ACCESS_ELEVATION_VALIDATE: '/v2/access-elevation/validate',
  ACCESS_ELEVATION_VALIDATE: '/v2/otp/validate',
  MFA_SEND_OTP: '/v2/mfa/send-otp',
  TAC_AUTHORIZATION_STATUS_RETRIEVE: '/v2/tac/authorization-status/retrieve',
  TAC_SOFT_TOKEN_RETRIEVE: '/v1/tac2/token/retrieve',
  TAC_TOKEN_RETRIEVE: '/v1/tac2/token/retrieve',
  TAC_VALIDATE: '/v2/tac/validate',
  GET_SECURITY_POLICY: '/v1/securityPolicy/inquiry/detail',
  TRANSACTION_SIGN_VERIFY: '/v1/tac/validate',
  MAINTENANCE_SIGN_VERIFY: '/v1/tac/validate-cr-otp',
  TRANSACTION_SIGN_REQUEST: '/v1/tac/soft-token/request',
  TRANSACTION_SIGN_VERIFY_OTP: '/v1/tac/common/verify-all-otp',
  TRANSACTION_SIGN_STATUS: '/v1/tac/soft-token/pullstatus',
  AUTH_REQUEST_DETAIL: '/v1/tac/auth-request/{id}',
  AUTH_REQUEST_DETAIL_TRX_ID: '/v1/tac/trx/{id}/auth-request',
  VERIFY_AUTH_REQUEST_STATUS: '/v1/tac/auth-request/verify/{id}',
};
